var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "closeProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3571237,20.0030439 L22.9608194,14.6158049 C23.1151177,14.4678244 23.2,14.2699707 23.2,14.0590049 C23.2,13.847922 23.1151177,13.6501854 22.9608194,13.5019707 L22.4697927,13.0301659 C22.3157379,12.8817171 22.1098039,12.8 21.890352,12.8 C21.6709001,12.8 21.4652096,12.8817171 21.3110331,13.0301659 L14.6389403,19.4441366 C14.4841549,19.5928195 14.3993944,19.7914927 14.4,20.0026927 C14.3993944,20.2148293 14.4840331,20.4132683 14.6389403,20.5620683 L21.3048222,26.9698341 C21.4589987,27.1182829 21.6646892,27.2 21.8842629,27.2 C22.1037148,27.2 22.3094053,27.1182829 22.4637036,26.9698341 L22.9546084,26.4980293 C23.2740437,26.1909463 23.2740437,25.6910439 22.9546084,25.384078 L17.3571237,20.0030439 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc-Discover-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open-profile-web-version-Copy-4",
    transform: "translate(-317.000000, -76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "closeProfile",
    transform: "translate(337.000000, 96.000000) rotate(-90.000000) translate(-337.000000, -96.000000) translate(317.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseProfile);
export default __webpack_public_path__ + "static/media/closeProfile.860c4022a10b2a177887e0b67f491198.svg";
export { ForwardRef as ReactComponent };